import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from '@/components/Dashboard/Dashboard'
import RecordList from '@/components/Record/RecordList'
import RecordCreate from '@/components/Record/RecordCreate'
import PackageManage from '@/components/Manage/Package'
import GameManage from '@/components/Manage/Game'
import UidImageManage from '@/components/Manage/UidImage'
import CreditLog from '@/components/Manage/CreditLog'
import WepayLog from '@/components/Manage/WepayLog'
import GamePackageManage from '@/components/Manage/GamePackage'
import MobileManage from '@/components/Manage/Mobile'
import MobilePackageManage from '@/components/Manage/MobilePackage'
import CardManage from '@/components/Manage/Card'
import CardPackageManage from '@/components/Manage/CardPackage'
import FlashPackage from '@/components/Manage/FlashPackage'
import ImageManage from '@/components/Manage/Image'
import BankAccountManage from '@/components/Manage/BankAccount'
import ContactManage from '@/components/Manage/Contact'
import MemberManage from '@/components/Manage/Member'
import TopupCredit from '@/components/Manage/TopupCredit'
import TopupGame from '@/components/Manage/TopupGame'
import TopupMobile from '@/components/Manage/TopupMobile'
import TopupCard from '@/components/Manage/TopupCard'
import UserManage from '@/components/Manage/User'
import UserProfile from '@/components/UserProfile'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import PageNotFound from '@/components/PageNotFound'
import PermissionDenied from '@/components/PermissionDenied'


Vue.use(VueRouter)

const routes = [
  {
    path: '/dashboard',
    name : 'dashboard',
    component: Dashboard,
    meta: { requireAuth: true ,group: 'dashboard'}
  },
    // {
    //   path: '/',
    //   name : 'record-list',
    //   component: RecordList,
    //   meta: { requireAuth: true ,group: 'record'}
    // },
    {
      path: '/package-list',
      name : 'package-list',
      component: RecordList,
      meta: { requireAuth: true ,group: 'record'}
    },
    {
      path: '/package-record',
      name : 'record-create',
      component: RecordCreate,
      meta: { requireAuth: true ,group: 'record'}
    },
    {
      path: '/package-manage',
      name : 'package-manage',
      component: PackageManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/game-manage',
      name: 'game-manage',
      component: GameManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/uid-image-manage',
      name: 'uid-image-manage',
      component: UidImageManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/game-package-manage',
      name: 'game-package-manage',
      component: GamePackageManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
    {
      path: '/mobile-manage',
      name: 'mobile-manage',
      component: MobileManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/mobile-package-manage',
      name: 'mobile-package-manage',
      component: MobilePackageManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
    {
      path: '/card-manage',
      name: 'card-manage',
      component: CardManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/card-package-manage',
      name: 'card-package-manage',
      component: CardPackageManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
    {
      path: '/flash-package-manage',
      name: 'flash-package-manage',
      component: FlashPackage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/contact-manage',
      name: 'contact-manage',
      component: ContactManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/image-manage',
      name: 'image-manage',
      component: ImageManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/bank-account-manage',
      name: 'bank-account-manage',
      component: BankAccountManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
      {
      path: '/member-manage',
      name: 'member-manage',
      component: MemberManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
      {
      path: '/topup-credit',
      name: 'topup-credit',
      component: TopupCredit,
      meta: { requireAuth: true ,group: 'manage'}
    },
    {
      path: '/topup-game',
      name: 'topup-game',
      component: TopupGame,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/topup-mobile',
      name: 'topup-mobile',
      component: TopupMobile,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/topup-card',
      name: 'topup-card',
      component: TopupCard,
      meta: { requireAuth: true ,group: 'manage'}
    },
      {
      path: '/credit-log',
      name: 'credit-log',
      component: CreditLog,
      meta: { requireAuth: true ,group: 'manage'}
    },
     {
      path: '/wepay-log',
      name: 'wepay-log',
      component: WepayLog,
      meta: { requireAuth: true ,group: 'manage'}
    },
    {
      path: '/user-manage',
      name: 'user',
      component: UserManage,
      meta: { requireAuth: true ,group: 'manage'}
    },
    {
      path: '/user-profile',
      name: 'user-profile',
      component: UserProfile,
      meta: { requireAuth: true }
    },
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: { requireAuth: false }
    },
     {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { requireAuth: false }
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: { requireAuth: false }
    },
    {
      path: '/permission-denied',
      name: 'permission-denied',
      component: PermissionDenied,
      meta: { requireAuth: true }
    },
    {
      path: '*',
      name: 'page-not-found',
      component: PageNotFound,
      meta: { requireAuth: false }
    },
]

const router = new VueRouter({
  mode: '',
  routes
})


router.beforeEach((to, from, next) => {
  
    if (to.meta.requireAuth && !localStorage.getItem('user')) {
        next({ name : "login" })
    }
    else{
        next()
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js